import { Dispatch, SetStateAction } from "react";

import { ChickenNuggets } from "./ChickenNuggets";
import { Arrows } from "./Arrows";

type Props = {
  imageUrls: string[];
  showArrows: boolean;
  showChickenNuggets: boolean;
  index: number;
  setIndex: Dispatch<SetStateAction<number>>;
  prevImage: () => void;
  nextImage: () => void;
};

export const Controls = ({
  imageUrls,
  showArrows,
  showChickenNuggets,
  index,
  setIndex,
  prevImage,
  nextImage,
}: Props) => {
  return (
    <>
      {showArrows && <Arrows {...{ prevImage, nextImage }} />}
      {showChickenNuggets && (
        <ChickenNuggets {...{ imageUrls, index, setIndex }} />
      )}
    </>
  );
};
